module.exports = __webpack_public_path__ + "img/Turbilatex Reagents 02.2(mid).af720afe.jpg";